import ProgramIllustration from "../../img/program‑illustration.svg";
import styles from "./RenaissanceCourseDropdown.module.css";
import { NAV_LINK_CONSTANTS } from "../../Constants/NavLinksContants";

const RenaissanceCourseDropdown = ({ isMobile = false }) => {
    const handleExploreClick = () => {
        window.open(`${NAV_LINK_CONSTANTS.RENAISSANCE_COURSE_URL}`, "_blank");
    };

    const disableScroll = () => {
        document.body.style.overflow = "hidden";
    };

    const enableScroll = () => {
        document.body.style.overflow = "auto";
    };

    return (
        <div
            className={styles.fellowshipContainer}
            onClick={handleExploreClick}
            onMouseEnter={!isMobile ? disableScroll : null}
            onMouseLeave={!isMobile ? enableScroll : null}
            style={isMobile ? { marginTop: "1rem" } : {}}
        >
            <div className={styles.fellowshipText}>
                <div className={styles.fellowshipProgramTitle}>Renaissance Plus</div>
                <div className={styles.launchTechCareerText}>DSA + MERN + LLD + Springboot</div>
            </div>
            <div
                className={styles.hoverBox}
                onMouseEnter={!isMobile ? disableScroll : null}
                onMouseLeave={!isMobile ? enableScroll : null}
            >
                <h4 className={styles.launchCareerhead}>All in one course</h4>
                <div className={styles.launchCareerImage}>
                    <img
                        src={ProgramIllustration}
                        alt="Launch Tech Career"
                        width={200}
                        height={150}
                    />
                </div>
                <div className={styles.hoverBoxButtons}>
                    <button>Learn from scratch</button>
                    <button>Mock Interviews</button>
                    <button>Industry Experts</button>
                    <button>Personalized Mentorship</button>
                </div>
                <button className={styles.exploreProgramBtn}>Explore the Program</button>
            </div>
        </div>
    );
};

export default RenaissanceCourseDropdown;
